import React from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import blogData from "../data/blogData.json";
import NavBar from "../Components/NavBar/NavBar";
import Footer from "../Components/Footer/Footer";

const BlogPost = () => {
    const { slug } = useParams();
    const post = blogData.find(p => p.slug === slug);

    if (!post) return <div className="py-5 text-center">Post not found</div>;

    return (
        <div className="blog-post">
            <Helmet>
                <title>{post.title} | DBS EMI Blog</title>
                <meta name="description" content={post.excerpt} />
            </Helmet>

            <NavBar />

            <Container className="py-5">
                <Row className="justify-content-center">

                    <Col lg={8}>
                        <Button
                            variant="outline-primary"
                            className="rounded-2 btn-sm btn-md btn-lg btn-xl btn-xxl mb-4"
                            onClick={() => window.history.back()}
                        >
                            ← Back to Blog
                        </Button>
                        <div className="mb-4">
                            <span className="badge bg-primary bg-opacity-10 text-primary">
                                {post.category}
                            </span>
                            <span className="text-muted ms-3">{post.date}</span>
                        </div>

                        <h1 className="display-5 fw-bold mb-4">{post.title}</h1>

                        <img
                            src={post.image}
                            alt={post.title}
                            className="img-fluid rounded-3 mb-4 w-100"
                            style={{ maxHeight: '400px', objectFit: 'cover' }}
                        />

                        <div className="content-section">
                            {post.content.map((paragraph, index) => (
                                <p key={index} className="mb-3">
                                    {paragraph}
                                </p>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>

            {/* Related Articles (optional) */}
            <Container className="pb-5">
                <Row className="justify-content-center">
                    <Col lg={8}>
                        <h3 className="fw-bold mb-4">More Articles</h3>
                        <Row className="g-4">
                            {blogData
                                .filter(p => p.slug !== slug)
                                .slice(0, 4)
                                .map(post => (
                                    <Col md={6} key={post.id}>
                                        <div className="card border-0 h-100 shadow-sm">
                                            <img
                                                src={post.image}
                                                className="card-img-top"
                                                alt={post.title}
                                                style={{ height: '200px', objectFit: 'cover' }}
                                            />
                                            <div className="card-body">
                                                <span className="badge bg-primary bg-opacity-10 text-primary mb-2">
                                                    {post.category}
                                                </span>
                                                <h5 className="card-title">{post.title}</h5>
                                                <Button
                                                    variant="link"
                                                    className="px-0 text-primary text-decoration-none"
                                                    href={`/blog/${post.slug}`}
                                                >
                                                    Read More
                                                </Button>
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                        </Row>
                    </Col>
                </Row>
            </Container>

            <Footer />
        </div>
    );
};

export default BlogPost;